// extracted by mini-css-extract-plugin
module.exports = {"hero-image":"heroImage-module--hero-image--2szZO","gatsby-image":"heroImage-module--gatsby-image--2S3bx","children":"heroImage-module--children--2U0ag"};